<!--
 * @FileDescription: 账户管理（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-15（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-15（最后更新时间）
 -->
<template>
    <div class="page-container role">
        <div class="page-container-height div-overflow">
            <div class="department-add"  @click="addAccount(1)" v-has="'system_role_add'">
                <img src="@/assets/image/add_account@2x.png"/>
                <span>新增角色</span>
            </div>
            <!--账户-->
            <div class="account-ul" >
                <template v-for="(item,index) in roleList">
                    <card-tem ref="cardTem" :index="index" :id="item.id" @onDelete="onDelete" :width="494" :height="200"  :key="item.id" >
                        <div class="role-item" >
                            <div class="role-item-left">
                                <div class="role-item-img">
                                    <img src="@/assets/image/kehu@2x.png"/>
                                </div>
                            </div>
                            <div class="role-item-right">
                                <div class="role-right-name">{{item.roleName}}</div>
                                <div class="role-right-name1">
                               <span class="role-right-span">
                                   <img src="@/assets/image/miaoshu@2x.png"/>
                                   角色描述
                               </span>
                                    {{item.description}}</div>
                            </div>
                        </div>
                        <div class="role-btn">
                            <div @click="onChangePower(item)" class="role-btn-account" v-has="'system_role_power'">权限设置</div>
                            <div class="role-btn-edit" @click="addAccount(2,item)" v-has="'system_role_edit'">编辑</div>
                        </div>
                    </card-tem>
                </template>
            </div>
            <roleModel ref="roleMdoel"   @updateRoleList="updateRoleList"></roleModel>
        </div>
    </div>
</template>
<script>
    import roleModel from  './model/roleModel'
    import cardTem from '@/components/card-temp'
    import {getRolePageList,delRole} from "@/utils/api";
    import {mixins} from "@/mixins/mixins";

    export default {
        mixins:[mixins],
        data() {
            return {
                isShow:false,
                powerObj:[],
                checkObj:[],
                roleList:[],
            }
        },
        components:{
            roleModel,cardTem
        },
        watch:{
            pageList: {
                handler(newValue, oldValue) {
                    console.log(newValue)
                    if(!this.isEmpty(newValue.result)){
                        this.roleList = this.pageList.result.records
                    }
                },
                deep: true
            },
        },
        mounted(){
            this.getRoleList()
        },
        created(){

        },
        methods: {
            /**
             * @description: 获取角色列表
             */
            getRoleList(){
                this.getPageList('/account/api/role/pageRole',
                    {   companyStoreId:this.$store.state.shopId,
                        pageNo:this.pagination.current,
                        pageSize:this.pagination.pageSize,
                    },{
                        'Content-Type':'application/json'
                    })
            },
            /**
             * @description: 删除回调（方法描述）
             */
            onDelete(index,id){
                if(this.$comm.has('system_role_delete')){
                      let data = {
                        id:id,
                    }
                    data =  this.$qs.stringify(data)
                    let headers = {
                        'Content-Type':'application/x-www-form-urlencoded'
                    }
                    delRole(data,headers,{
                        companyStoreId:this.$store.state.shopId,
                    }).then(res => {
                        if (res.success) {
                            this.$message.success(res.logMessage)
                            this.$comm.removeByIndex(this.roleList,index)
                        }else{
                            this.$message.warn(res.logMessage)
                        }
                    })
                }else{
                    this.$message.warn('您没有权限进行此操作哦～')
                }
                data =  this.$qs.stringify(data)
                let headers = {
                    'Content-Type':'application/x-www-form-urlencoded'
                }
                delRole(data,headers,{
                    companyStoreId:this.$store.state.shopId,
                }).then(res => {
                    if (res.success) {
                        this.$message.success(res.logMessage)
                        this.$comm.removeByIndex(this.roleList,index)
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            },
            /**
             * @description: 更新角色列表（方法描述）
             */
            updateRoleList(){
                this.getRoleList()
            },
            /**
             * @description:新增或编辑角色（方法描述）
             */
            addAccount(index,item){
                if(index == 1){
                    this.$refs.roleMdoel.openRole(index)
                }else if(index == 2){
                    this.$refs.roleMdoel.openRole(index,item)
                }

            },
            /**
             * @description:角色分配权限弹框（方法描述）
             */
            onChangePower(item){
                this.checkObj = []
                this.$refs.roleMdoel.openPower(item)
            },
        },

    }
</script>
<style>
    .role .account-li-content{
        height: 200px;
    }
    .role .ant-checkbox-wrapper{
        line-height: 50px;
    }
</style>
<style lang="scss" scoped>
    .role{
        background-color: #fff;
        padding:  20px 80px 20px;
        .page-container-height {
            height: calc(100vh - 155px - 45px);
            overflow: auto;
        }
    }
    .account-ul{
        padding-top: 30px;
        display: flex;
        flex-wrap: wrap;
        padding-left: 20px;
    }
    .role-item{
        display: flex;
        align-items: center;
        padding-top: 40px;
        .role-item-left{
            flex: 0 0 116px;
            display: flex;
            justify-content: center;
            .role-item-img{
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background:linear-gradient(-76deg,rgba(54,127,255,0.1),rgba(27,147,234,0.1));
                display: flex;
                align-items: center;
                justify-content: center;
                img{
                    width: 36px;
                }
            }
        }
        .role-item-right{
            color: #555555;
            font-size: 15px;
            .role-right-name{
                color: #333333;
                font-weight: 700;
                margin-bottom: 25px;
            }
            .role-right-name1{
                display: flex;
                color: #555555;
                .role-right-span{
                    color: #AAAAAA;
                    margin-right: 12px;
                    img{
                        width: 12px;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    .role-btn{
        padding-top: 40px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 45px;
        .role-btn-account{
            cursor: pointer;
            color: #387BFC;
        }
        .role-btn-edit{
            cursor: pointer;
            margin-left: 24px;
            color: #387BFC;
        }
    }
</style>
